export default __webpack_public_path__ + "static/media/wicanders.8f8ca096.svg";